export const SYSTEM_SERVER_ERROR_CODE = {
    DOCUMENT_NOT_EXIST: { code: 5000, i18n: "documentNotFound" },
    DOCUMENT_NOT_FOUND: { code: 5001, i18n: "documentNotFoundPublic" },
    EMAIL_NOT_FOUND: { code: 5002, i18n: "nonExistentEmail" },
    REPORT_ID_NOT_FOUND: { code: 5003, i18n: "nonExistentReportId" },
    USER_NOT_FOUND: { code: 5004, i18n: "userNotFoundPublic" },
    DEVICE_ID_NOT_FOUND: { code: 5005, i18n: "deviceIdNotFound" },
    USER_ORIGIN_SYSTEM_NOT_FOUND: { code: 5006, i18n: "insufficientRights" },
    INVALID_CODE: { code: 5200, i18n: "invalidToken" },
    INVALID_TOKEN: { code: 5201, i18n: "invalidResetToken" },
    EXPIRED_TOKEN: { code: 5202, i18n: "expiredResetToken" },
    EXPIRED_CODE: { code: 5203, i18n: "expiredToken" },
    INVALID_CPF: { code: 5204, i18n: "invalidCPF" },
    INVALID_CNPJ: { code: 5205, i18n: "invalidCNPJ" },
    INVALID_USER_PASSWORD: { code: 5206, i18n: "invalidCredentials" },
    INVALID_CURRENT_PASSWORD: { code: 5207, i18n: "invalidCurrentPassword" },
    DISABLED_USER: { code: 5300, i18n: "disabledUserPublic" },
    CANNOT_EQUAL_OLD_NEW_PASSWORD: { code: 5350, i18n: "newPasswordSameAsCurrent" },
    CANNOT_EQUAL_NEW_CONFIRMATION_PASSWORD: { code: 5351, i18n: "newPasswordMismatch" },
    INVALID_CONFIRMATION_PASSWORD: { code: 5352, i18n: "invalidConfirmPassword" },
    EXIST_CPF: { code: 5400, i18n: "cpfAlreadyRegistered" },
    EXIST_CNPJ: { code: 5401, i18n: "cnpjAlreadyRegistered" },
    EXIST_EMAIL: { code: 5402, i18n: "emailAlreadyRegistered" },
    EXIST_EMAIL_CONFIRMATION: { code: 5403, i18n: "emailAlreadyRegisteredSystem" },
    UNAUTHORIZED: { code: 5500, i18n: "unauthorized" },
    USER_PHONE_NOT_FOUND: {code: 5007, i18n: "userPhoneNotFound"},
    USER_CANNOT_DELETE: {code: 5501, i18n: "userCannotDelete"},
};